import { Injectable } from '@angular/core';
import { Observable,  BehaviorSubject } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from '../common/message.service';
import { Permission, response, UserType } from '../common/interface';
import { environment } from "../../../environments/environment.prod";
import { CookieService } from './cookies';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _isloggedin: BehaviorSubject<boolean>;
  private _userType : BehaviorSubject<UserType>;
  private permission : Permission = {
    solicitorFirm : null,
    solicitor : null,
    barrister : null,
    case : null,
    archieved : null,
    client : null,
    court : null,
    conferrence : null,
    invoice : null,
    report : null, 
    user : null,
    permission : null,
    setting : null,
    holiday : null,
    document : null,
    notes : null,
    diary : null,
    dashboard : null
  };

  private userType : UserType = {
    userTypeId : null,
    barristerId : 0
  }

  private _permission: BehaviorSubject<Permission>;

  constructor(
    private http: HttpClient, 
    private router : Router, 
    private cookies : CookieService,
    private msg : MessageService
  ) { 
    let userId = this.cookies.getCookie('userToken');
    if(userId!= null){
        this._isloggedin = new BehaviorSubject<boolean>(true);
    }else{
        this._isloggedin = new BehaviorSubject<boolean>(false);
    }
    this._permission = new BehaviorSubject<Permission>(this.permission);
    this._userType = new BehaviorSubject<UserType>(this.userType);
  }

  

  getUserType() : Observable<UserType>{
    return this._userType.asObservable();
  }

  


  tryLogin(data){
    return this.http.post<response>(environment.url+"users/login", data).subscribe(res =>{
      // console.log(res);
      if(res.status == 'ok'){
        localStorage.setItem('currentUser', res.data.userToken);
        localStorage.setItem('userName', res.data.userName);
        this._permission.next(res.data.permission);
        this._userType.next(res.data.userType);
        this._isloggedin.next(true);
        this.router.navigate(['/pages/home']);
      }else{
        this._isloggedin.next(false);
        this.msg.error(res.message);
      }
    });
  }

  isLoggedIn(): Observable<boolean>{
    return this._isloggedin.asObservable();
  }

  setLogin(){
    this._isloggedin.next(true);
  }

  checkLanding(){
    let userId = localStorage.getItem("currentUser");
    if(userId == null){
      this.logOut();
    }else{
      this.http.post<response>(environment.url + "users/landing", null).subscribe(res=> {
        // console.log('check landing');
        // console.log(res);
            if(res.status == 'ok'){
              this._isloggedin.next(true);
              this._permission.next(<Permission>res.data.permission);
              this._userType.next(<UserType>res.data.userType);
              // console.log(res.data.permission);
            }else{
              // this.logOut();
            }
      })
    }
    // if(userId != null){
    //   await this.http.get<response>(environment.url + "users/landing").subscribe(res=> {
    //     if(res.status == 'ok'){
    //       this._isloggedin.next(true);
    //       this._permission.next(<Permission>res.data.permission);
    //     }else{
    //       // this.logOut();
    //     }
    //   })
    // }else{
    //   this.logOut();
    // }
  }

  getPermission() : Observable<Permission>{
    return this._permission.asObservable();
  }

  getUserName(){
      if(localStorage.getItem('userName') != null){
        return localStorage.getItem('userName');
      }else{
        // this.logOut();
      }
  }

  logOut(){
    this._isloggedin.next(false);
    this._permission.next(this.permission);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userName');
    this.router.navigate(['/auth/login']);
    this.msg.success("Successfully, logged out !");
  }

}
